module.exports = __webpack_public_path__ + "assets/verifiera.82b805e5.png";


//////////////////
// WEBPACK FOOTER
// ../source/assets/verifiera.png
// module id = 1222
// module chunks = 26